import { get, put } from "../../api_helper";
import * as url from "../../url_helper";

export const apiGetMaster = () => get(url.API_MASTER);
export const apiGetMasterArea = () => get(url.API_MASTER_AREAS);
export const apiGetMasterDeg = () => get(url.API_MASTER_DEG);
export const apiUpdateMasterDeg = (data) => put(url.API_MASTER_DEG, data);
